// extracted by mini-css-extract-plugin
module.exports = {"card":"ForgotPassword_card__SikZS","titleStyle":"ForgotPassword_titleStyle__1uUj_","linkStyle":"ForgotPassword_linkStyle__2n2SD"};